import React from "react"
import { Box, Flex, Text, Image } from "@theme-ui/components"
import { getReferencePath } from "../utils/path"
import { GatsbyImage } from "gatsby-plugin-image"
import { InboundLink } from "./link"

const ReferenceThumb = ({ reference }) => {
  // console.log(reference)
  const placeholder = {
    en: "Read the case study",
    it: "Leggi il caso studio",
    de: "Lesen Sie die Fallstudie",
    fr: "Lire l'étude de cas",
  }
  const text = placeholder[reference.locale]
  return (
    <Box
      sx={{
        borderRadius: "sm",
        backgroundColor: "primary",
        borderRadius: "0 22px",
        a: {
          transition: "all .3s ease-in-out",
        },
        "&:hover": {
          a: { opacity: 0 },
        },
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          height: "100%",
          width: "100%",
          color: "light",
        }}
      >
        <Flex
          sx={{
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <Text sx={{ fontFamily: "montserrat" }}> {text}</Text>
        </Flex>
      </Box>
      <InboundLink to={getReferencePath(reference, reference.locale)}>
        <Box
          sx={{
            height: "182px",
            width: "100%",
            borderRadius: "0 20px",
            overflow: "hidden",
            backgroundColor: "light",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            ".gatsby-image-wrapper": {
              width: "80%",
              height: "auto",
            },
          }}
        >
          {reference.logo && (
            <GatsbyImage image={reference.logo.standard} alt="" />
          )}
        </Box>
      </InboundLink>
    </Box>
  )
}

export default ReferenceThumb
